'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var slideOutUp = {
  from: {
    transform: (0, _utils.translate3d)(0, 0, 0)
  },
  to: {
    visibility: 'hidden',
    transform: (0, _utils.translate3d)(0, '-100%', 0)
  }
};
exports.default = slideOutUp;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/slide-out-up.js
// module id = 262
// module chunks = 54990529738226 257444579329143